// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__AqAK7","spin":"Spinner_spin__q+LU7","sm":"Spinner_sm__09HLi","md":"Spinner_md__xPQX8","lg":"Spinner_lg__R238l"};